import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { PETS_DOCUMENTS } from "../enums/QueryKeys";
import { PET_DETAILS_ } from "../enums/UrlPaths";
import { DOCUMENTS } from "../features/pets/enums/TabsRequestParams";
import { useFetch } from "../hooks/Fetching";
import { handlers } from "../components/appointmentsWithDocuements/AppointmentsWithDocuments";
const petDocumentsParams = {
  search: "q",
  startDate: "from",
  endDate: "to",
  category: "cat",
  fileExtension: "extension",
};
//TODO: on clearing search data make sure to completely remove the data from the url
//If this comment is left that means this wasn't fixed and should be informed during PR
export const DocumentAppointmentFilterContext = React.createContext();
//DON'T CHANGE THE SUFIX FROM LS TO PARAMS, WE DON'T KNOW ALL THE PLACES IT'S BEING CALLED AT
export const CATEGORY_LS = petDocumentsParams?.category;
export const FILE_EXTENSION_LS = petDocumentsParams?.fileExtension;
export const TITLE_LS = petDocumentsParams?.search;
export const DATE_START_LS = petDocumentsParams?.startDate;
export const DATE_END_LS = petDocumentsParams?.endDate;

export default function FilterAppointmentsWithDocuments({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const { id: petId } = useParams();
  const url = PET_DETAILS_ + petId + "?tab=" + DOCUMENTS;
  const key = PETS_DOCUMENTS + petId;
  const { data, isLoading, error } = useFetch(url, null, key);
  
  const [filterCategory, setFilterCategory] = React.useState(
    getParamsNumber(CATEGORY_LS)
  );
  
  const [filterFileExtension, setFilterFileExtension] = React.useState(
    getParamsString(FILE_EXTENSION_LS)
  );
  
  const [filterTitle, setFilterTitle] = React.useState(
    getParamsString(TITLE_LS)
  );

  const [filterDate, setFilterDate] = React.useState({
    start: getParamsFilter(DATE_START_LS),
    end: getParamsFilter(DATE_END_LS),
  });
  
  const [fetchValues, setFetchValues] = React.useState({
    categories: [],
    fileExtensions: [],
  });

  function getCategoryFilter() {
    return filterCategory;
  }

  function getFilterFileExtensions() {
    return filterFileExtension;
  }

  function getTitleFilter() {
    return filterTitle;
  }

  function getDateFilter() {
    return filterDate;
  }

  function reset() {
    searchParams.delete(CATEGORY_LS);
    searchParams.delete(TITLE_LS);
    searchParams.delete(DATE_END_LS);
    searchParams.delete(DATE_START_LS);
    searchParams.delete(FILE_EXTENSION_LS);
    handleFilterCategory("");
    handleFilterFileExtension("");
    handleFilterTitle("");
    handleFilterDate({ startDate: null, endDate: null }); // Set null instead of empty string
    setFetchValues({
      fileExtensions: data?.extensions || [],
      categories: data?.documentCategoriesList || [],
    });
    
    searchParams.delete(handlers.ord);
  
    setSearchParams(searchParams);
  }

  function setParamsFilter(setVal, val) {
    if (val != null && val != undefined && val != "") {
      params.set(setVal, val);
    } else {
      params.set(setVal, val); //Stupid but the date filter doesn't reset unless we set the value to null first
      params.delete(setVal);
    }
    setSearchParams(params);
  }

  function getParamsNumber(key) {
    var storedVal = searchParams.get(key);
    if (
      storedVal != null &&
      storedVal != undefined &&
      String(storedVal).length > 0
    ) {
      return Number(storedVal);
    }
    return "";
  }

  function getParamsString(key) {
    var storedVal = searchParams.get(key);
    if (storedVal != null && storedVal != undefined) {
      return String(storedVal);
    }
    return "";
  }

  function getParamsFilter(key) {
    var storedVal = searchParams.get(key);
    if (storedVal != null && storedVal != undefined) {
      return storedVal;
    }
    return "";
  }

  //Filtering documentCategoriesList by category
  function handleFilterCategory(val) {
    setParamsFilter(CATEGORY_LS, val);
    setFilterCategory(val);
  }

  //Filtering appointment by service
  function handleFilterFileExtension(val) {
    setParamsFilter(FILE_EXTENSION_LS, val);
    setFilterFileExtension(val);
  }

  //Filtering documentCategoriesList by title
  function handleFilterTitle(val) {
    setParamsFilter(TITLE_LS, val);
    setFilterTitle(val);
  }

  //Filtering appointments by date range
  function handleFilterDate(val) {
    setParamsFilter(DATE_START_LS, val?.startDate);
    setParamsFilter(DATE_END_LS, val?.endDate);
    setFilterDate({
      start: val?.startDate,
      end: val?.endDate,
    });
  }

  const values = {
    fetchValues,
    data,
    handleFilterCategory,
    handleFilterFileExtension,
    handleFilterTitle,
    handleFilterDate,
    reset,
    getCategoryFilter,
    getFilterFileExtensions,
    getTitleFilter,
    getDateFilter,
    error,
    isLoading,
  };

  return (
    <DocumentAppointmentFilterContext.Provider value={values}>
      {children}
    </DocumentAppointmentFilterContext.Provider>
  );
}
